import { types as t } from 'mobx-state-tree';

export const JobVisibility = t.enumeration('JobVisibility', ['private', 'public']);
